import { useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { apolloService } from '../../common/services'

import { DELETE_DIET_MUTATION } from '../graphql/mutations'
import { DELETE_DIET } from '../redux/action-types'

const useDeleteDietMutation = refetchLastEvent => {
  const dispatch = useDispatch()

  const { isLoading, error } = useSelector(
    store => store.diets.dietsAndDietCategories,
  )

  const mutate = useCallback(
    async id => {
      await apolloService.mutate(
        DELETE_DIET_MUTATION,
        {
          id,
        },
        dispatch,
        DELETE_DIET,
      )

      refetchLastEvent()
    },
    [dispatch, refetchLastEvent],
  )

  return [mutate, { isLoading, error }]
}

export default useDeleteDietMutation
